import Phaser from 'phaser'
import { SCALE, TILES_BY_SCREEN, TILE_SIZE } from '../utils/constants'
import CRTFilter from '../utils/CRTShaderFX'
import UI from '../components/UI'

export default class ConnectorScene extends Phaser.Scene {
  constructor () {
    super('ConnectorScene');
  }
  
  preload () {
    
  }

  createAnimations() {
    this.anims.create({
      key: 'closeUp_Mary',
      frames:this.anims.generateFrameNumbers('closeUp', { frames: [ 0 ] }),
      repeat: 0,
    })
    this.anims.create({
      key: 'closeUp_Marduk',
      frames:this.anims.generateFrameNumbers('closeUp', { frames: [ 1 ] }),
      repeat: 0,
    })
    this.anims.create({
      key: 'closeUp_Dwarf',
      frames:this.anims.generateFrameNumbers('closeUp', { frames: [ 2 ] }),
      repeat: 0,
    })
    this.anims.create({
      key: 'closeUp_Tiamat',
      frames:this.anims.generateFrameNumbers('closeUp', { frames: [ 3 ] }),
      repeat: 0,
    })
  }
  getMusicFromName(name) {
    switch(name) {
      case 'cinematic_1':
        return 'swarf_chat_music'
      default:
        return 'generic_chat_music'
    }
  }
  
  getImageByName(name) {
    let image, scaleX, scaleY, scale
    switch(name) {
      default:
      case 'cinematic_1':
        image = this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 1.5, 'Tiamat')
        scaleX = this.cameras.main.width / image.width
        scaleY = this.cameras.main.height / image.height
        scale = Math.max(scaleX, scaleY)
        image.setScale(scale * 4).setScrollFactor(0)
        break
      case 'cinematic_last':
        image = this.add.image(this.cameras.main.width /2, this.cameras.main.height/2, 'Tiamat')
        scaleX = this.cameras.main.width / image.width
        scaleY = this.cameras.main.height / image.height
        scale = Math.max(scaleX, scaleY)
        image.setScale(scale).setScrollFactor(0)
        break
      case 'cinematic_last_2':
        image = this.add.image(this.cameras.main.width /2, this.cameras.main.height/2, 'thechild')
        scaleX = this.cameras.main.width / image.width
        scaleY = this.cameras.main.height / image.height
        scale = Math.max(scaleX, scaleY)
        image.setScale(scale).setScrollFactor(0)
        break
    }
    return image
  }
  create({id, name}) {
    this.currentLevel = id
    this.createAnimations()
    const musicName = this.getMusicFromName(name)
    this.environmentMusic = this.sound.add(musicName, { loop: true });
    this.environmentMusic.play();

    new UI(this, true)

    this.cameras.main.setPostPipeline(CRTFilter);
    let image = this.getImageByName(name)
    image.name = 'background_art'

    this[`showDialogLevel_${name}`]()
    
  }
  showDialogLevel_cinematic_escape() {
    // hack to get control after dialogue close
    this.levels = {
      current: {
        pause: () => false,
        resume: () => {
          setTimeout(() => {
            this.environmentMusic.stop()
            // this.environmentMusic.destroy()
            this.cameras.main.fade(1000, 0, 0, 0)
            this.cameras.main.once('camerafadeoutcomplete', () => void this.scene.start('GameScene', { level: this.currentLevel + 1 }))
          }, 1000);
        }
      }
    }

    this.events.emit('dialogue:show', {
      participants: ['closeUp_Marduk', 'closeUp_Mary'],
      conversation: [
        {
          who: 'closeUp_Marduk',
          text: [
            "Do you feel it Mary?",
            "Do you feel her presence",
            "below?",
          ]
        },
        {
          who: 'closeUp_Mary',
          text: [
             "I do... But what",
             "does it mean?",
          ]
        },
        {
          who: 'closeUp_Marduk',
          text: [
             "That I do not know... But",
             "it does not portend well.",
             "I have learned so much in",
             "so little time. Mary...I",
             "can’t recognize the man",
             "I once was. I felt",
             "bound by obligation,",
             "I was trapped, Mary."
          ]
        },
        {
          who: 'closeUp_Mary',
          text: [
             "It is time, Marduk",
             "we have to escape",
             "from here before",
             "Tiamat stops us",
             " ",
             "go!!!"
          ]
        },
      ]
    })

  }

  showDialogLevel_cinematic_last_2() {
    // hack to get control after dialogue close
    this.levels = {
      current: {
        pause: () => {
          this.tweens.add({
            targets: this.children.getByName('background_art'),
            alpha: 0,
            duration: 500,
            onComplete: () => {
              const img = this.getImageByName('cinematic_last_2')
              img.alpha = 0
              this.tweens.add({
                targets: img,
                alpha: 1,
                duration: 500,
              })
            }
          })
        },
        resume: () => {
          setTimeout(() => {
            this.tweens.add({
              targets:this.environmentMusic,
              valume: 0,
              duration: 500,
            })
            
            this.cameras.main.fade(1000, 0, 0, 0)
            this.cameras.main.once('camerafadeoutcomplete', () => void this.scene.start('CreditsScene'))
          }, 1000);
        }
      }
    }
    this.events.emit('dialogue:show', {
      participants: ['closeUp_Marduk', 'closeUp_Dwarf'],
      conversation: [
        {
          who: 'closeUp_Dwarf',
          text: [
             "That's not how things work",
             "where I come from. Marduk,",
             "You have been preparing",
             "for this moment since",
             "your life began. Do you",
             "have the courage to",
             "forge your own destiny?",
          ]
        },
      ]
    })
    
  }
  showDialogLevel_cinematic_last() {
    // hack to get control after dialogue close
    this.levels = {
      current: {
        pause: () => false,
        resume: () => {
          setTimeout(() => {
            this.showDialogLevel_cinematic_last_2()
            // this.cameras.main.fade(1000, 0, 0, 0)
            // this.cameras.main.once('camerafadeoutcomplete', () => void this.scene.start('GameScene', { level: this.currentLevel + 1 }))
          }, 1000);
        }
      }
    }

    this.events.emit('dialogue:show', {
      participants: ['closeUp_Marduk', 'closeUp_Tiamat'],
      conversation: [
        {
          who: 'closeUp_Marduk',
          text: [
            "How could you do this? We",
            "are your creations. This",
            "is your land. How could",
            "you lie to us!?",
            "Why have you forsaken us?",
          ]
        },
        {
          who: 'closeUp_Tiamat',
          text: [
            "Life is a cycle. The",
            "catalyst comet is a part",
            "of this cycle: I did not",
            "lie when I said the Comet",
            "was the source of the",
            "earthquakes.",
          ]
        },
        {
          who: 'closeUp_Tiamat',
          text: [
             "However: I am a force of",
             "this world. It is through",
             "my actions that things",
             "occur. I am bound to the",
             "will of the comet: for",
             "truly we are one. I am",
             "nature: and this...is",
             "within my nature.",
          ]
        },
        {
          who: 'closeUp_Tiamat',
          text: [
             "I may have created",
             "everything, yet still:",
             "there was a natural order",
             "to life that preceded me.",
          ]
        },
        {
          who: 'closeUp_Tiamat',
          text: [
             "You are finite in your",
             "perspective Marduk.",
             "Death signifies new",
             "beginnings.",
             " ",
             "This is Destiny.",
          ]
        },
        {
          who: 'closeUp_Marduk',
          text: [
             "Who would accept a fate",
             "such as this? We have done",
             "no wrong. We worship and",
             "revere you. We are your",
             "children! Would you",
             "really destroy us?",
          ]
        },
        {
          who: 'closeUp_Tiamat',
          text: [
            "The end was written",
            "in the beginning.",
            "Fate cannot be rewritten."
          ]
        },
      ]
    })
  }
  showDialogLevel_cinematic_1() {
    // hack to get control after dialogue close
    this.levels = {
      current: {
        pause: () => false,
        resume: () => {
          setTimeout(() => {
            this.tweens.add({
              targets: this.environmentMusic,
              volume: 0,
              duration: 500,
            })
            this.cameras.main.fade(1000, 0, 0, 0)
            this.cameras.main.once('camerafadeoutcomplete', () => void this.scene.start('GameScene', { level: this.currentLevel + 1 }))
          }, 1000);
        }
      }
    }
    this.events.emit('dialogue:show', {
      participants: ['closeUp_Mary', 'closeUp_Marduk', 'closeUp_Dwarf'],
      conversation: [
        {
          who: 'closeUp_Mary',
          text: [
            "There you are! I was",
            "worried about you!",
            "Are you okay?",
          ]
        },
        {
          who: 'closeUp_Marduk',
          text: [
            "- marduk has been crying -",
            "Thank Tiamat You’re here!",
            "I made a mistake. I ate",
            "one of the mushrooms. I",
            "don’t feel well…I think I",
            "broke my leg falling from",
            "the surface.",
          ]
        },
        {
          who: 'closeUp_Mary',
          text: [
            "Are you going to",
            "throw up!?",
            "Can you stand?",
          ]
        },{
          who: 'closeUp_Marduk',
          text: [
            "No….I don’t think so.",
          ]
        },
        {
          who: 'closeUp_Mary',
          text: [
            "What are we going to do",
            "with you.",
          ]
        },
        {
          who: 'closeUp_Dwarf',
          text: [
            "You know…..there's",
            "nothing wrong with being",
            "sad or afraid. It’s",
            "nature's way of guiding",
            "us towards a brighter",
            "future.",
          ]
        },
        {
          who: 'closeUp_Marduk',
          text: [
            "WHAT ON EARTH IS THAT!?",
            "Don’t patronize me foul",
            "beast.",
          ]
        },
        {
          who: 'closeUp_Mary',
          text: [
            "You really need to learn",
            "when to shut your mouth.",
            "Marduk. You have become",
            "rude & foul tempered.",
          ]
        },
        {
          who: 'closeUp_Dwarf',
          text: [
            "I mean he’s right.",
            "I am a monster.",
            "I'm... different."
          ]
        },
        {
          who: 'closeUp_Mary',
          text: [
            "You don’t seem like",
            "a monster to me.",
          ]
        },
        {
          who: 'closeUp_Dwarf',
          text: [
            "That’s because we're",
            "going to make a deal"
          ]
        },
        {
          who: 'closeUp_Marduk',
          text: [
            "I don’t make deals with...",
            "your kind...",
          ]
        },
        {
          who: 'closeUp_Dwarf',
          text: [
            "But You Will...in time...",
            "things change. People grow.",
            "Even you Marduk. I think",
            "we could be great friends.",
            "In Fact. It Is Prophecy",
          ]
        }
      ]
    }) 
  }
}
